import React from 'react';
import { TextField, SelectField, Button } from '@dopomogai/ui';

type Filters = {
  industry?: string;
  status?: string;
  priceBand?: string;
  search?: string;
};

type Props = {
  value: Filters;
  onChange: (next: Filters) => void;
  industries?: string[];
  statuses?: string[];
  priceBands?: string[];
};

export function InvestFiltersBar({ value, onChange, industries = [], statuses = [], priceBands = [] }: Props) {
  return (
    <div className="bg-white border-b-2 border-black">
      <div className="max-w-6xl mx-auto px-6 py-4 grid gap-3 md:grid-cols-4">
        <TextField
          label="Search"
          value={value.search || ''}
          onChange={(e) => onChange({ ...value, search: e.target.value })}
          placeholder="Agent name"
        />
        <SelectField
          name="industry"
          label="Industry"
          value={value.industry || ''}
          onChange={(v) => onChange({ ...value, industry: String(v) || undefined })}
          options={[{ value: '', label: 'Any' }, ...industries.map((i) => ({ value: i, label: i }))]}
        />
        <SelectField
          name="status"
          label="Status"
          value={value.status || ''}
          onChange={(v) => onChange({ ...value, status: String(v) || undefined })}
          options={[{ value: '', label: 'Any' }, ...statuses.map((s) => ({ value: s, label: s }))]}
        />
        <SelectField
          name="priceBand"
          label="Price band"
          value={value.priceBand || ''}
          onChange={(v) => onChange({ ...value, priceBand: String(v) || undefined })}
          options={[{ value: '', label: 'Any' }, ...priceBands.map((p) => ({ value: p, label: p }))]}
        />
      </div>
    </div>
  );
}


